import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/homepage/ClientReels.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/homepage/ComparisonTable.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/homepage/CTASection.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/homepage/FAQ.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/homepage/Features.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/homepage/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/homepage/Hero.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/homepage/HowItWorks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/homepage/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/homepage/SmoothScroll.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/homepage/styles/homepage.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/homepage/TemplateShowcase.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/homepage/Testimonials.tsx");
